import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";

# راهنمای خانواده‌های بررسی کیفی

در این صفحه شما می‌توانید انواع بررسی‌های کیفی تعریف شده در سیستم را مدیریت کنید.

## ویژگی‌ها
- **لیست خانواده‌ها:** مشاهده تمامی خانواده‌های کنترل کیفی به همراه وضعیت آن‌ها.
- **ایجاد و ویرایش:** امکان تعریف خانواده‌های جدید و ویرایش رویه‌های فعلی.
- **مدیریت نسخه‌ها:** هر خانواده کیفی می‌تواند دارای نسخه‌های مختلف (Revisions) باشد تا تغییرات در طول زمان قابل رهگیری باشند.

export default function Page({ children }) {
  return <Layout>{children}</Layout>;
}
